import React from 'react'
import Pulse from 'react-reveal/Pulse'

import { SectionContainer, SectionTitle, CTA } from '../../_common'
import { GasCard } from '../../_projectCommon'
import { Grid } from '@material-ui/core'

import useStyles from './styles'
import { lightTheme } from '../../../App.theme'

import { BsArrowRightShort } from 'react-icons/bs'

const OurServices = () => {
  const { wrapper } = useStyles()

  const cards = [
    {
      title: 'Consultoría actuarial',
      text: 'Obligaciones laborales y principios contables',
    },
    {
      title: 'Consultoría en planes de beneficios',
      text: 'Soluciones acorde a las necesidades del negocio',
    },
    {
      title: 'Asesoría patrimonial',
      text: 'Brindamos soluciones en finanzas personales',
    },
  ]

  return (
    <SectionContainer
      sectionID="services"
      backgroundColor={lightTheme.palette.extras.slate}
    >
      <SectionTitle centered title="Nuestros servicios" />

      <Pulse>
        <Grid container className={wrapper}>
          {cards.map((card, i) => (
            <GasCard key={i} {...{ card }} />
          ))}
        </Grid>

        <CTA
          btnRoute="/servicios"
          btnText="Ver más"
          icon={<BsArrowRightShort />}
        />
      </Pulse>
    </SectionContainer>
  )
}

export default OurServices
